import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { useShowAlert } from 'hooks';
import API from 'services/API';
import strings from 'strings';
import { getErrorMessage } from 'UI/utils';

import { CallSummaryTable } from '../CallSummaryTable';

const COPIES = strings.phoneDashboard.sections.callSummaryTable;

const formatSummaryData = apiData => {
  if (!apiData) return null;

  return {
    grandTotal: apiData?.grandTotal || 0,
    inboundConnected: apiData?.inbound?.connected || 0,
    inboundMissed: apiData?.inbound?.notConnected || 0,
    outboundConnected: apiData?.outbound?.connected || 0,
    outboundNotConnected: apiData?.outbound?.notConnected || 0
  };
};

export const CallSummaryContainer = ({ url }) => {
  const { showAlert } = useShowAlert();
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    const shouldExecuteRequest = !!url;

    const fetchData = async () => {
      try {
        const { data } = await API.get(url);
        if (!mounted) return;

        const formatted = formatSummaryData(data);
        setSummary(formatted);
      } catch (err) {
        if (mounted) {
          setError(err.message || err);
          showAlert({
            severity: 'error',
            title: COPIES.error.title,
            autoHideDuration: 5000,
            body: getErrorMessage(err || COPIES.error.message)
          });
        }
      } finally {
        if (mounted) {
          setIsLoading(false);
        }
      }
    };

    shouldExecuteRequest && fetchData();
    return () => {
      mounted = false;
    };
  }, [showAlert, url]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box>
        <Typography color="error" variant="body1">
          {COPIES.error.message}
        </Typography>
      </Box>
    );
  }

  if (!summary) {
    return (
      <Box p={4}>
        <Typography variant="body1">{COPIES.emptyState.message}</Typography>
      </Box>
    );
  }

  return <CallSummaryTable {...summary} />;
};
